





import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import LaunchWeApp from '@/components/LaunchWeApp.vue';
import { showDialog } from '@/fit-components/dialog/main';
import { isOSVerLargeOrEqualThan, isWexinVerLargeOrEqualThan, getWeixinVer, getOSInfo } from '@/utils/client';
import { report } from '@tencent/ppd-report-sdk-web';
import { CustomException } from '@/utils/error';
function getSupportLaunchWeAppMap() {
  return {
    system: isOSVerLargeOrEqualThan({ iphone: '10.3', android: '5.0' }),
    wechat: isWexinVerLargeOrEqualThan('7.0.12'),
  };
}

function getIsSupportLaunchWeApp() {
  const supportLaunchMap = getSupportLaunchWeAppMap();
  // 判断是否是ios15，且微信版本<8.0.9，兼容拉起小程序
  // TODO: 是否判断iPad iOS 15待港陆一起确定
  const isNotSuportWxOpenLaunchWeapp = navigator.userAgent.includes('CPU iPhone OS 15') && isWexinVerLargeOrEqualThan('8.0.9');
  if (isNotSuportWxOpenLaunchWeapp) {
    report.reportInfo({
      key: 'not_suport_OpenLaunchWeapp_device',
      msg: getWeixinVer(),
    });
    new CustomException(null, 'not_suport_OpenLaunchWeapp', '不支持开放标签打开小程序');
  }

  if (supportLaunchMap.system && supportLaunchMap.wechat && !isNotSuportWxOpenLaunchWeapp) return true;
  // 如果匹配不到 上报到elk
  const data = {
    // @ts-ignore
    wxuserAgent: navigator.wxuserAgent,
    userAgent: navigator.userAgent,
    supportLaunchMap,
    wxVersion: getWeixinVer(),
    os: getOSInfo(),
  };
  new CustomException(data, 'h5OpenMiniappNotSupport', `机型不支持h5打开小程序:${JSON.stringify(data)}`);
  return false;
}

@Component({
  components: {
    LaunchWeApp,
  },
})
export default class LuanchWeApp extends Vue {
  @Prop() path;// 小程序访问路径
  @Prop() username;// 小程序原始id
  @Prop({ default: '确认打开' }) btnText;// 按钮文案
  @Emit()
  public onSuccess() {

  }
  @Emit()
  public onError() {

  }
  public onLaunchWeAppTouch() {
    const supportLaunchMap = getSupportLaunchWeAppMap();
    const isSupportLaunchWeApp = getIsSupportLaunchWeApp();
    // 低端机型判断
    if (!isSupportLaunchWeApp) {
      let title = '';
      if (!supportLaunchMap.system && !supportLaunchMap.wechat) {
        title = '由于你的手机系统版本和微信版本过低，暂时无法确认收款，请分别升级后再试';
      } else if (!supportLaunchMap.system) {
        title = '由于你的系统版本过低，暂时无法确认收款，请升级后再试';
      } else {
        title = '由于你的微信版本过低，暂时无法确认收款，请升级后再试';
      }
      showDialog({
        title,
        btns: [{
          text: '我知道了',
        }],
      });
    }
  }
}
